<template>
  <p-change-password v-if="$hasPermission('users.read')" />
  <p-not-found v-else />
</template>

<script>
import ChangePassword from './../components/users/ChangePassword.vue';
import NotFound from './../components/NotFound.vue';

export default {
  components: {
    'p-change-password': ChangePassword,
    'p-not-found': NotFound
  }
};
</script>
